module.exports = __webpack_public_path__ + "img/adix_nt_header_logo.8e124eb8.png";